program WebCoreClient;

{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  UDatamodule in 'UDatamodule.pas',
  ULogin in 'ULogin.pas'{*.html},
  UMainMenu in 'UMainMenu.pas'{*.html},
  UOrdersMain in 'UOrdersMain.pas'{*.html},
  UOrders in 'UOrders.pas'{*.html},
  UErrorHandling in 'UErrorHandling.pas',
  UHelper in 'UHelper.pas',
  UResources in 'UResources.pas',
  UJSHelper in 'UJSHelper.pas',
  WEBLib.WebTools,
  System.SysUtils,
  USmptJSWrapper in 'USmptJSWrapper.pas',
  UUsersMain in 'UUsersMain.pas'{*.html},
  UUser in 'UUser.pas'{*.html},
  UCustomerSelect in 'UCustomerSelect.pas'{*.html},
  ULogisticOverview in 'ULogisticOverview.pas'{*.html},
  UAnalysis in 'UAnalysis.pas'{*.html},
  UFirstLogin in 'UFirstLogin.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;

  Application.CreateFormDirect(TUDM, UDM);
  THelper.DebugODS('Application Starts');

  Application.Run;
end.
